export default {
    apiBaseUrl: process.env.REACT_APP_API_URL
    // apiBaseUrl: 'http://localhost:3001/api/v1'
    // apiBaseUrl: 'https://4758-2405-201-681f-50ac-fd6b-518e-f64c-9386.in.ngrok.io/api/v1'
}